export default __webpack_public_path__ + "static/media/AdobeStock_322507117.abe08df1.jpg";